import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent } from '@guildeducationinc/recess';
import EditIcon from '@guildeducationinc/recess/icons/EditIcon';
import { AdminTopNav } from '@src/components/Admin/AdminTopNav/AdminTopNav';
import { EditWorkflow } from '@src/components/Admin/Workflows/EditWorkflow';
import { useClientIdParam } from '@src/hooks/useClientIdParam';
import { useWorkflows } from '@src/hooks/useWorkflows';
import { WorkflowType } from '@src/types';
import { getPolicyNavLinks } from '@src/utilities/topNavHelper';
import { camelCase } from 'lodash';
import { DataTable, TrackableButton, useLocale } from 'pe-core-frontend';
import { useState } from 'react';
export const WorkflowsList = () => {
    const clientId = useClientIdParam() || 0;
    const { t } = useLocale();
    const { workflows, loading } = useWorkflows({ clientId });
    const [selectedWorkflow, setSelectedWorkflow] = useState(null);
    return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: t('Policy'), navLinks: getPolicyNavLinks(t, clientId, 'workflows'), actions: _jsx(TrackableButton, { btnType: 'mui', enText: 'Add Workflow', tag: 'header', variant: 'contained', onClick: () => setSelectedWorkflow({
                        id: 0,
                        clientId,
                        name: '',
                        type: WorkflowType.PROGRAM_APPROVAL,
                        executeConcurrently: false,
                        isActive: true,
                    }), children: t('Add Workflow') }) }), _jsxs("div", { children: [!selectedWorkflow && (_jsx(_Fragment, { children: _jsx(DataTable, { loading: loading, disableColumnMenu: true, disableRowSelectionOnClick: true, rows: workflows || [], hideFooter: true, columns: [
                                {
                                    field: 'name',
                                    headerName: t('Workflow Name'),
                                    flex: 0.2,
                                    sortable: false,
                                },
                                {
                                    field: 'type',
                                    headerName: t('Workflow Type'),
                                    flex: 0.2,
                                    sortable: false,
                                    renderCell: ({ value }) => t(`WorkflowType.${camelCase(value)}`),
                                },
                                {
                                    field: 'executeConcurrently',
                                    headerName: t('Execute Concurrently?'),
                                    flex: 0.2,
                                    sortable: false,
                                    valueGetter: e => (e.row.executeConcurrently ? 'Yes' : 'No'),
                                },
                                {
                                    field: 'isActive',
                                    headerName: t('Active?'),
                                    valueGetter: e => (e.row.isActive ? 'Yes' : 'No'),
                                    flex: 0.2,
                                    sortable: false,
                                },
                                {
                                    field: 'action',
                                    headerName: t('Actions'),
                                    renderCell: ({ row }) => (_jsx("div", { children: _jsx(TrackableButton, { btnType: 'icon', enText: 'Edit', tag: `workflow_${row.id}`, label: t('Edit'), appearance: 'minimal', icon: _jsx(EditIcon, { size: 20 }), onClick: () => setSelectedWorkflow(row), className: 'margin--right_8' }) })),
                                    width: 100,
                                    sortable: false,
                                },
                            ] }) })), selectedWorkflow && (_jsx(Card, { children: _jsx(CardContent, { children: _jsx(EditWorkflow, { workflow: selectedWorkflow, onSave: () => setSelectedWorkflow(null), onCancel: () => setSelectedWorkflow(null) }) }) }))] })] }));
};
